module.exports = __webpack_public_path__ + "static/travaux-537904b2fe159dc3a588f74a251f8022.jpeg";